<template>
  <div>

    <!--Banner Parallax-->
    <section class="topBanner" ref="parallaxBanner" :style="{ backgroundPositionY: parallaxOffset + 'px' }">
      <div class="bannerOverlay">
        <img class="iconBanner" src="/Resources/images/icon/Analyse-deau_hover.png"/>
        <h1 class="bannerTitle">{{ $t('sectionBanner.Title') }}</h1>
      </div>
    </section>

    <!--Section Why-->
    <section class="boxSectionWhy">
      <v-row class="d-flex flex-wrap-reverse justify-center">
        <v-col class="txt-j sectionWhyTextPad minBoxImg">
          <div>
            <h2 class="pumpSectionTitle">{{ $t('sectionWhy.title') }}</h2>
            <h3 class="sSlogan">{{ $t('sectionWhy.slogan') }}</h3>
            <h4 class="sectionWhyTitlePar">{{ $t('sectionWhy.physicochimiqueSubtitle') }}</h4>
            <p v-html="$t('sectionWhy.physicochimiqueTxt')"></p>
            <p class="pt-4 pb-4" v-html="$t('sectionWhy.procedureTxt')"></p>
            <router-link to="analyseEau/#Form" class="button buttonText">{{ $t('sectionWhy.linkAnalysis') }}</router-link>
          </div>
        </v-col>
        <v-col class="py-0 minBoxImg">
          <div class="bgSectionWhyPhoto"></div>
        </v-col>
      </v-row>
    </section>

    <!--Section NewHome-->
    <section class="bgSectionNewHome">
      <v-row class="d-flex justify-center">
        <v-col class="py-0 minBoxImg">
          <div class="bgSectionNewHomePhoto1"></div>
        </v-col>
        <v-col class="txt-j sectionNewHomeTextPad minBoxImg">
          <v-row>
            <h2 class="sectionNewBacTitle">{{ $t('sectionWhy.bacteriologicalSubtitle') }}</h2>
            <p class="pb-4" v-html="$t('sectionWhy.bacteriologicalTxt')"></p>
            <router-link to="/contact" class="button buttonText">{{ $t('sectionWhy.linkContactUs') }}</router-link>
          </v-row>
          <v-row class="mt-10">
            <h2 class="sectionNewHomeTitle">{{ $t('sectionNewHome.title') }}</h2>
            <p class="pb-4" v-html="$t('sectionNewHome.txt')"></p>
          </v-row>
        </v-col>
      </v-row>
    </section>

    <!--TypeWater-->
    <section class="gridpad2 sectionPad" id="TypeWater">
      <v-row class="mb-6">
        <v-col cols="12">
          <div class="typeTitle">
            <img class="iconFormat" src="/Resources/images/icon/Probleme-eau-verre_Hover.png"/>
            <h2 class="pumpSectionTitle">{{ $t('sectionTypeWater.title') }}</h2>
            <h3 class="sSlogan">{{ $t('sectionTypeWater.subtitle') }}</h3>
          </div>
        </v-col>
        <v-col v-for="(item, i) in Types" :key="i">
          <v-container class="typeItem pa-0 d-flex justify-start">
            <div>
              <img class="typeImg" :src="item.img"/>
            </div>
            <div class="typeBoxTxt">
              <h3 class="pumpSectionSubtitle">{{ $t(item.subtitle) }}</h3>
              <p class="txt-j" v-html="$t(item.txt)"></p>
            </div>
          </v-container>
        </v-col>
      </v-row>
    </section>

    <!--Form-->
    <section id="Form" class="sectionPad">
      <v-row class="gridpad2">
        <h2 class="pumpSectionTitle">{{ $t('form.title') }}</h2>
      </v-row>
      <div class="gridpad mt-5">
        <v-row>
          <v-col cols="12"><p v-html="$t('form.select')"></p></v-col>
          <v-col cols="12">
            <v-select v-model="select2" :items="ItemChoix2" item-title="title" item-value="value" label="Choix" variant="outlined" return-object></v-select>
          </v-col>
        </v-row>
        <v-row v-if="select2.value == '1'">
          <v-col><p v-html="$t('form.selectLocalChoice')"></p></v-col>
        </v-row>
        <v-row v-if="select2.value == '0'">
          <v-col cols="12">
            <form ref="form">
              <v-row>
                <v-col cols="12" lg="6" class="px-5">
                  <v-row class="">
                    <!--name-->
                    <v-col cols="12">
                      <p class="bold f-secondary" v-if="!error.name" style="font-size: 14px;" v-html="$t('form.name')"></p>
                      <p class="bold error" v-if="error.name" style="font-size: 14px;" v-html="$t('form.name')"></p>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field @change="error.name = false" id="name" name="name" type="text" v-model="item.name" bg-color="blue-lighten-5" clearable required />
                      <p class="errorText" v-if="error.name" style="font-size: 14px; margin-top: -25px;">** Un nom est requis**</p>
                    </v-col>
                    <!--email-->
                    <v-col cols="12"><p class="bold f-secondary" style="font-size: 14px;" v-html="$t('form.mail')"></p></v-col>
                    <v-col cols="12"><v-text-field id="Courriel" name="Courriel" type="text" v-model="item.email" bg-color="blue-lighten-5" clearable required /></v-col>
                    <!--phone-->
                    <v-col cols="12">
                      <p class="bold f-secondary" v-if="!error.phone" style="font-size: 14px;" v-html="$t('form.phone')"></p>
                      <p class="bold error" v-if="error.phone" style="font-size: 14px;" v-html="$t('form.phone')"></p>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field id="Telephone" name="Telephone" type="text" label="xxx xxx-xxxx" v-model="item.phone" bg-color="blue-lighten-5" clearable required />
                      <p class="errorText" v-if="error.phone" style="font-size: 14px; margin-top: -25px;">Un téléphone est requis **</p>
                    </v-col>
                    <!--city-->
                    <v-col cols="12"><p class="bold f-secondary" style="font-size: 14px;" v-html="$t('form.city')"></p></v-col>
                    <v-col cols="12"><v-text-field id="Ville" name="Ville" type="text" v-model="item.location" bg-color="blue-lighten-5" clearable required /></v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" lg="6" class="px-5">
                  <!--treatment-->
                  <v-row>
                    <v-col cols="12"><p class="bold f-secondary" style="font-size: 14px;" v-html="$t('form.system')"></p></v-col>
                    <v-col cols="12"><v-select id="treatment" name="treatment" type="text" v-model="item.treatment" bg-color="blue-lighten-5" :items="[$t('form.systemYes'), $t('form.systemNo')]" clearable required /></v-col>
                  </v-row>
                  <!--problems-->
                  <v-row>
                    <v-col cols="12"><p class="bold f-secondary" style="font-size: 14px;" v-html="$t('form.problems')"></p></v-col>
                    <v-col cols="12"><v-select id="Problematiques" name="Problematiques" type="text" clearable chips v-model="item.problems" bg-color="blue-lighten-5" :items="[$t('form.problemLimestone'), $t('form.problemRust'), $t('form.problemChlorine'), $t('form.problemYellow'), $t('form.problemCorrosive')]" multiple required /></v-col>
                  </v-row>
                  <!--describe-->
                  <v-row>
                    <v-col cols="12"><p class="bold f-secondary" style="font-size: 14px;" v-html="$t('form.problemsDesc')"></p></v-col>
                    <v-col cols="12"><v-textarea clearable required no-resize id="description" name="description" v-model="item.Message" label="Description" bg-color="blue-lighten-5" rows="7" row-height="45" single-line :counter="520" maxlength="520"/></v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!--Send-->
              <v-row class="d-flex flex-lg-row flex-column">
                <v-col cols="12" lg="6" class="d-flex align-center justify-md-center justify-start">
                  <p v-if="Dialog == 'error'" style="color: red; margin-left:15px;">{{ $t('form.error') }}</p>
                </v-col>
                <v-col cols="12" lg="6" class="d-flex align-center justify-md-end justify-center">
                  <v-btn v-if="Dialog != 'send'" @click="SendForm();" class="button" style="margin-right:15px;">
                    <span class="buttonText2" v-if="Dialog == 'notSend' || Dialog == 'error'">{{ $t('form.send') }}</span>
                    <span class="buttonText2" v-if="Dialog == 'pending'">{{ $t('form.wait') }}</span>
                  </v-btn>
                  <h3 id="waterAnlysisFormSent" v-if="Dialog == 'send'" class="f-primary" style="text-align: center; font-size: 2em;">{{ $t('form.complete') }}</h3>
                </v-col>
              </v-row>
            </form>
          </v-col>
        </v-row>
      </div>
    </section>

  </div>
</template>

<style scoped>
  p { font-size: 18px; color: rgba(var(--menuColor), 0.6); }
  .sectionPad { padding: 50px 0px; }
  .gridpad { padding: 0px 50px 50px 50px; }
  .gridpad2 { padding: 0px 50px; }
  .minBoxImg { min-width: 525px; }
  .iconFormat { width: 50px; height: 50px; margin-bottom: -15px; }

  /*#region Banner Parallax*/
  .topBanner {
    height: 600px;
    background-image: url('../../public/Resources/images/WaterAnalysis/banner_analysis.jpg');
    background-attachment: fixed;
    background-position: center 30%;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    will-change: background-position-y;
  }
  .bannerOverlay {
    background-color: rgba(0, 0, 0, 0.45);
    padding: 40px 70px;
    border-radius: 8px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    max-width: 700px;
  }
  .iconBanner { width: 55px; height: 55px; }
  .bannerTitle {
    color: #ffffff;
    font-weight: 700;
    font-size: 32px;
    text-transform: uppercase;
    letter-spacing: 2px;
    margin: 0;
  }
  /*#endregion*/

  /*#region Unified Titles*/
  .pumpSectionTitle { color: rgb(var(--secondary)); font-weight: 700; font-size: 26px; }
  .pumpSectionSubtitle { color: rgb(var(--secondary)); font-weight: 600; font-size: 18px; }
  .sSlogan { color: rgba(var(--menuColor), 0.8); font-weight: 500; font-size: 22px; padding: 0px 0px 15px 0px; }
  .sectionWhyTitlePar { color: rgba(var(--menuColor), 0.8); font-weight: 700; font-size: 22px; padding: 15px 0px 0px 0px; }
  /*#endregion*/

  /*#region Why section*/
  .boxSectionWhy { padding: 0px 0px 22px 0px; }
  .sectionWhyTextPad { padding: 50px; }
  .bgSectionWhyPhoto {
    background-image: url("../../public/Resources/images/WaterAnalysis/child_water.jpg");
    height: 100%; width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  /*#endregion*/

  /*#region NewHome section*/
  .bgSectionNewHome { background-color: rgb(var(--tierce2)); }
  .bgSectionNewHomePhoto1 {
    background-image: url("../../public/Resources/images/WaterAnalysis/Maison-Neuve-Analyse-eau.jpg");
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .sectionNewHomeTextPad { padding: 50px; }
  .sectionNewBacTitle { color: rgb(var(--secondary)); font-weight: 700; font-size: 26px; text-transform: uppercase; padding: 0px 0px 15px 0px; }
  .sectionNewHomeTitle { color: rgba(var(--menuColor), 0.8); font-weight: 700; font-size: 22px; text-transform: uppercase; padding: 0px 0px 15px 0px; }
  /*#endregion*/

  /*#region TypeWater*/
  .typeTitle { text-align: center; padding: 50px 0px 50px 0px; }
  .typeItem { height: 150px; width: 100%; max-width: 450px; min-width: 450px; position: relative; display: block; margin: auto auto !important; }
  .typeImg { height: 150px; width: 150px; }
  .typeBoxTxt { padding: 0px 0px 0px 30px; }
  /*#endregion*/

  @media handheld, only screen and (max-width: 600px) {
    .topBanner { height: 400px; background-attachment: scroll; }
    .bannerTitle { font-size: 22px; }
    .bannerOverlay { padding: 25px 20px; }
    .minBoxImg { min-width: 100%; margin-left: auto; margin-right: auto; display: block; }
    .typeTitle { padding: 50px 0px 0px 0px; }
    .gridpad { padding: 0px 15px 50px 15px; }
    .gridpad2 { padding: 0px 0px; }
    .typeItem { min-width: 100%; }
  }
  @media handheld, only screen and (max-width: 960px) {
    .topBanner { height: 500px; background-attachment: scroll; }
    .gridpad { padding: 0px 25px 50px 25px; }
    .gridpad2 { padding: 0px 25px 50px 25px; }
    .sectionWhyTextPad { padding: 25px 30px 30px 30px; }
    .sectionNewHomeTextPad { padding: 15px 25px 45px 25px; }
  }
  @media handheld, only screen and (max-width: 1279px) {
    .topBanner { height: 500px; background-attachment: scroll; }
    .bgSectionWhyPhoto { height: 350px; background-position-y: 65%; background-repeat: no-repeat; background-size: 100%; }
    .bgSectionNewHomePhoto1 { height: 350px; background-position: center; background-repeat: no-repeat; background-size: cover; }
    .gridpad2 { padding: 0px 25px 50px 25px; }
    .sectionNewHomeTextPad { padding: 15px 25px 45px 25px; }
  }
  @media handheld, only screen and (max-width: 1378px) {
    .sectionWhyTextPad { padding: 25px 30px 30px 30px; }
  }
</style>

<script>
  import pageTranslations from '../../public/Resources/i18N/waterAnalysis.json';

  export default {
    name: 'waterAnalysis',
    data: () => ({
      parallaxOffset: 0,
      select2: { title: 'Locataire / Tenant', value: '1' },
      cart: null,
      item: {
        name: null,
        email: null,
        phone: null,
        address: null,
        location: null,
        treatment: null,
        problems: null,
        Message: null
      },
      Dialog: 'notSend',
      error: {
        name: false,
        phone: false
      },
      key: '',
      showForm: true,
      ItemChoix2: [
        { title: 'Proprietaire / Homeowner', value: '0' },
        { title: 'Locataire / Tenant', value: '1' },
      ],
      Types: [
        { img: '/Resources/images/WaterAnalysis/typeWater_calcaire.jpg', subtitle: 'sectionTypeWater.subLimestone', txt: 'sectionTypeWater.txtLimestone' },
        { img: '/Resources/images/WaterAnalysis/typeWater_rust.jpg', subtitle: 'sectionTypeWater.subRust', txt: 'sectionTypeWater.txtRust' },
        { img: '/Resources/images/WaterAnalysis/typeWater_chlore.jpg', subtitle: 'sectionTypeWater.subChlorine', txt: 'sectionTypeWater.txtChlorine' },
        { img: '/Resources/images/WaterAnalysis/typeWater_odor.jpg', subtitle: 'sectionTypeWater.subOdor', txt: 'sectionTypeWater.txtOdor' },
        { img: '/Resources/images/WaterAnalysis/typeWater_jaune.jpg', subtitle: 'sectionTypeWater.subYellow', txt: 'sectionTypeWater.txtYellow' },
        { img: '/Resources/images/WaterAnalysis/typeWater_corrosive.jpg', subtitle: 'sectionTypeWater.subCorrosive', txt: 'sectionTypeWater.txtCorrosive' },
        { img: '/Resources/images/WaterAnalysis/typeWater_nonpotable.jpg', subtitle: 'sectionTypeWater.subNonPotable', txt: 'sectionTypeWater.txtNonPotable' },
      ],
    }),
    methods: {
      handleParallax() {
        if (!this.$refs.parallaxBanner) return;
        this.parallaxOffset = Math.round(window.scrollY * 0.4);
      },
      validation: async function () {
        let valid = true;
        let errorFlag = { name: false, phone: false };
        if (this.item.name == null || this.item.name.length == 0) { valid = false; errorFlag.name = true; }
        if (this.item.phone == null || this.item.phone.length < 12) { valid = false; errorFlag.phone = true; }
        this.error = errorFlag;
        return valid;
      },
      login: async function () {
        let api = 'https://abstracxion.wx3data.com/security/login/BissonService';
        try {
          let response = await fetch(api, {
            method: 'PUT',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify({ LoginName: '', password: '' })
          });
          if (await response.ok) {
            if (await response.status !== 204) {
              return await response.text();
            }
          }
        } catch (error) {
          console.log(error);
        }
      },
      SendForm: async function () {
        this.Dialog = 'pending';
        let valid = await this.validation();
        if (valid == true) {
          let formData = new FormData(this.$refs.form);
          let api = 'https://abstracxion.wx3data.com/eCommerce/Forms/ContactUs/sendByEmail';
          try {
            let token = await this.login();
            let response = await fetch(api, {
              method: 'POST',
              mode: 'cors',
              cache: 'no-cache',
              credentials: 'same-origin',
              headers: { 'Authorization': 'Bearer ' + token },
              redirect: 'follow',
              referrerPolicy: 'no-referrer',
              body: formData
            });
            if (await response.ok) {
              if (await response.status !== 204) { this.Dialog = 'send'; }
            } else {
              this.Dialog = 'error';
            }
          } catch (error) {
            this.Dialog = 'error';
          }
        } else {
          this.Dialog = 'error';
        }
      },
    },
    mounted() {
      this.$i18n.mergeLocaleMessage('fr', pageTranslations.fr);
      this.$i18n.mergeLocaleMessage('en', pageTranslations.en);
      window.addEventListener('scroll', this.handleParallax);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleParallax);
    },
    components: {},
  }
</script>